import * as S from './index.style'

export type CartaoProps = {
  titulo: string
  children: React.ReactNode
  className?: string
}

export const Cartao: React.FC<CartaoProps> = ({ titulo, children, className }) => {
  return (
    <S.Wrapper className={className}>
      <S.Title>{titulo}</S.Title>
      {children}
    </S.Wrapper>
  )
}
export default Cartao
